import React, { useRef, useState, useEffect } from 'react';
import CreateBlankModal from './CreateBlankModal';
import './AddDocumentModal.css';
import { Link } from 'react-router-dom';
import Templates from "../Templates"; 
import TemplatesTable from "../TemplatesTable"  // adjust path if needed


const AddDocumentModal = ({ isOpen, onClose, onSelectTemplate,onSave,parentNode, prefillContractData, isPrefillLoading}) => {
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState('');
  const [selectedFile, setSelectedFile] = useState(null); // Store the file object
  const [isCreateBlankModalOpen, setIsCreateBlankModalOpen] = useState(false);
  const [isTemplatesPopupOpen, setIsTemplatesPopupOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templatesLoading, setTemplatesLoading] = useState(false);
  const [contextMenu, setContextMenu] = useState({
  visible: false,
  node: null,
  contractId: null,
});
  const [userName, setUserName] = useState('');
  const [fileError, setFileError] = useState('');

  // Read user name from sessionStorage like in Sidebar.js
  useEffect(() => {
    const storedName = sessionStorage.getItem('user_name') || 'User';
    setUserName(storedName);
  }, []);




  if (!isOpen) return null;

  // Handle click on the "Select File" button to trigger file input
  const handleSelectFileClick = () => {
    fileInputRef.current.click();
  };

  // Handle file selection
  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     setFileName(file.name);
  //     setSelectedFile(file); // Store the file object
  //     console.log('Selected file:', file);
  //   } else {
  //     setFileName('');
  //     setSelectedFile(null);
  //   }
  // };
  const handleFileChange = (event) => {
  const file = event.target.files[0];
  if (file) {
    const allowedExtensions = ['.pdf', '.doc', '.docx'];
    const fileExt = file.name.toLowerCase().slice(file.name.lastIndexOf('.'));
    if (!allowedExtensions.includes(fileExt)) {
      setFileError('Only .pdf, .doc, and .docx files are allowed');
      setFileName('');
      setSelectedFile(null);
      if (fileInputRef.current) {
  fileInputRef.current.value = '';
}
      return;
    }
    setFileError('');
    setFileName(file.name);
    setSelectedFile(file);
    console.log('Selected file:', file);
  } else {
    setFileName('');
    setSelectedFile(null);
    setFileError('');
   if (fileInputRef.current) {
  fileInputRef.current.value = '';
}
  }
};

  // Handle drag and drop
  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) {
      setFileName(file.name);
      setSelectedFile(file); // Store the file object
      console.log('Dropped file:', file);
    }
  };

  // Prevent default drag-over behavior
  const handleDragOver = (event) => {
    event.preventDefault();
  };

  // Handle Create Blank click
  const handleCreateBlank = () => {
    setSelectedFile(null);
    setIsCreateBlankModalOpen(true);
  };

  // Handle save from CreateBlankModal
  const handleSave = (formData) => {
    console.log('Saved form data:', formData, 'with file:', selectedFile);
    setFileName(''); // Reset file selection
    setSelectedFile(null);
    setIsCreateBlankModalOpen(false);
    onClose(); // Close both modals
  };

  // Handle cancel or close from CreateBlankModal
const handleCreateBlankModalClose = () => {
  setFileName(''); // Reset file selection
  setSelectedFile(null);
  setFileError(''); // Reset any file error
  if (fileInputRef.current) {
    fileInputRef.current.value = ''; // Clear the file input only if ref exists
  }
  setIsCreateBlankModalOpen(false);
};

  // Handle Select Template click
  const handleSelectTemplateClick = () => {
    onClose(); // Close the modal
    onSelectTemplate(); // Call the prop function if provided
    // Redirect is handled by the Link component below
  // Handle close of AddDocumentModal
  }
  const handleModalClose = () => {
  setFileName(''); // Reset file selection
  setSelectedFile(null);
  setFileError(''); // Reset any file error
  if (fileInputRef.current) {
  fileInputRef.current.value = '';
}
  setIsCreateBlankModalOpen(false); // Ensure CreateBlankModal is closed
  onClose(); // Trigger parent onClose
};

  // Handle continue after file selection
  const handleFileContinue = () => {
    console.log('Continue with file:', fileName);
    setIsCreateBlankModalOpen(true); // Open CreateBlankModal
  };

  return (
  <>
    {/* Main Add Document Modal */}
    <div className="modal-overlay" onClick={handleModalClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <div className="modal-title">
            <h2>Hi, {userName}! 👋</h2>
            <p>How would you like to create a contract today? 🚀</p>
          </div>
          <button className="close-btn" onClick={handleModalClose}>
            <span>×</span>
          </button>
        </div>

        {/* Options */}
        <div className="modal-options">
          {/* File Upload */}
          <div
            className="option-card upload-area"
            onDrop={handleDrop}
            onDragOver={handleDragOver}
          >
            <div className="upload-zone">
              <div className="upload-text">
                {fileName ? `Selected: ${fileName}` : "Upload New/Existing contract"}
              </div>
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
                accept=".pdf,.doc,.docx"
              />
              <button
                className="upload-btn"
                onClick={
                  fileName ? handleFileContinue : handleSelectFileClick
                }
              >
                <span className="upload-icon">
                  {fileName ? "🚀" : "📁"}
                </span>
                <span>{fileName ? "Continue" : "Select File"}</span>
              </button>
              {fileError && (
    <div className="error" style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>
      {fileError}
    </div>
  )}
            </div>
          </div>

          {/* Create Blank */}
          <div className="option-card" onClick={handleCreateBlank}>
            <div className="option-content">
              <div className="option-text">Create Blank</div>
              <div className="option-icon">✨</div>
            </div>
          </div>

          {/* Select Template */}
          <div
            className="option-card"
            onClick={() => { setTemplatesLoading(true); setIsTemplatesPopupOpen(true); }}
            title="Select from available templates"
          >
            <div className="option-content">
              <div className="option-text">Select a Template</div>
              <div className="option-icon">📄</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Create Blank Modal */}
    <CreateBlankModal
      isOpen={isCreateBlankModalOpen}
      onClose={handleCreateBlankModalClose}
      onSave={onSave}
      uploadedFile={selectedFile}
      parentNode={contextMenu.node}
       selectedTemplate={selectedTemplate}
      prefillContractData={prefillContractData}
      isPrefillLoading={isPrefillLoading}
    />

    {/* Templates Popup */}
    {isTemplatesPopupOpen && (
  <div className="modal-overlay" onClick={() => setIsTemplatesPopupOpen(false)}>
    <div className="modal-content large" style={{ boxShadow:'0 10px 25px rgba(0,0,0,0.15)', borderRadius:'10px' }} onClick={(e) => e.stopPropagation()}>
      <div className="modal-header" style={{ borderBottom:'1px solid #f1f1f1', padding:'12px 16px' }}>
        <h2 style={{ margin:0 }}>Available Templates</h2>
        <button className="close-btn" onClick={() => setIsTemplatesPopupOpen(false)} title="Close">×</button>
      </div>
      <div className="modal-body" style={{ padding:'12px 16px' }}>
        {templatesLoading && (
          <div style={{ display:'flex', alignItems:'center', justifyContent:'center', padding:'30px' }}>
            <div className="spinner" style={{ width:24, height:24, border:'3px solid #ffe3d6', borderTopColor:'#ff6b35', borderRadius:'50%', animation:'spin 1s linear infinite' }} />
          </div>
        )}
        <TemplatesTable 
          onLoaded={() => setTemplatesLoading(false)}
  onSelect={(template) => {
   console.log("Selected template (full object):", JSON.stringify(template, null, 2));
  console.log("Selected template_name:", template?.name || "undefined");
    setIsTemplatesPopupOpen(false);     // close template popup
    setSelectedFile(null);              // clear file if any
    setIsCreateBlankModalOpen(true);    // open CreateBlankModal
    setSelectedTemplate({
      template_id: template.template_id,
      template_name: template.name || "", // Explicitly include template_name
    });   // 👈 store selected template in state
  }} 
/>

      </div>
    </div>
  </div>
)}

  </>
);

};

export default AddDocumentModal;
